import { DealType } from '@/types/writeup';
import { prop, VueWithProps } from 'vue-class-component';
import { IconNames } from '@/components/icon';
import type { VueI18n } from 'vue-i18n';

export interface DealTypeValue {
	type: DealType;
	value: number | undefined;
}

export interface IconMap {
	[index: string]: IconNames;
}

export class DealTypeSelectorProps {
	active = prop<DealType | undefined>({ default: null })

	values = prop<DealTypeValue[]>({ default: [] })

	onTypeChange = prop<Function>({ default: () => () => undefined })

	onDetailsClick = prop<Function>({ default: () => () => undefined })

	loading = prop<boolean>({ default: false })

	staticBar = prop<boolean>({ default: false })
}

export interface DealTypeSelectorClass extends VueWithProps<DealTypeSelectorProps> {
	i18n: VueI18n;

	sticked: boolean;

	staticBar: boolean;

	type: DealType | undefined;

	observer: IntersectionObserver | undefined;

	getValueString(type: string, value: number | undefined): string;

	handleTypeChange(type: string): void;
}
